import React from 'react';
import CPFMaskInput from '../masks/CPFMaskInput';
import CNPJMaskInput from '../masks/CNPJMaskInput';
import TelefoneMaskInput from '../masks/TelefoneMaskInput';
import CelularMaskInput from '../masks/CelularMaskInput';
import CEPMaskInput from '../masks/CEPMaskInput';

function limparTelefone(telefone) {
  return telefone ? telefone.replace(/\D/g, '').slice(0, 10) : '';
}
function limparCelular(celular) {
  return celular ? celular.replace(/\D/g, '').slice(0, 11) : '';
}

function FavorecidoModal({ show, onClose, onSubmit, form, handleChange, ufs = [], cidades = [], title = 'CADASTRO DE FAVORECIDO', onBuscarCnpj, isBuscandoCnpj = false, isEditing = false }) {
  if (!show) return null;

  function handleSubmit(e) {
    e.preventDefault();
    const formLimpo = {
      ...form,
      telefone: limparTelefone(form.telefone),
      celular: limparCelular(form.celular)
    };
    onSubmit(formLimpo);
  }

  return (
    <div className="modal show d-block" tabIndex="-1"
      style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1055, position: 'fixed', inset: 0 }}>
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header bg-success text-white" style={{ padding: '0.35rem 1rem' }}>
            <h6 className="modal-title mb-0 small"><i className="bi bi-person-check me-2"></i>{title}</h6>
            <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-3 mb-3">
                  <label className="form-label">Tipo *</label>
                  <select className="form-select" name="tipo" value={form.tipo} onChange={handleChange} required disabled={isEditing}>
                    <option value="">Selecione</option>
                    <option value="PF">PF - Pessoa Física</option>
                    <option value="PJ">PJ - Pessoa Jurídica</option>
                  </select>
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">CPF/CNPJ *</label>
                  <div className="input-group">
                    {form.tipo === 'PF' && <CPFMaskInput name="cpfOrCnpj" value={form.cpfOrCnpj} onChange={handleChange} required disabled={isEditing} />}
                    {form.tipo === 'PJ' && <CNPJMaskInput name="cpfOrCnpj" value={form.cpfOrCnpj} onChange={handleChange} required disabled={isEditing} />}
                    {!form.tipo && <input type="text" className="form-control" name="cpfOrCnpj" value={form.cpfOrCnpj} onChange={handleChange} placeholder="Selecione o tipo primeiro" disabled />}
                    {form.tipo === 'PJ' && (
                      <button type="button" className="btn btn-outline-secondary" onClick={onBuscarCnpj} disabled={isBuscandoCnpj} title="Buscar dados na Receita Federal">
                        {isBuscandoCnpj
                          ? <span className="spinner-border spinner-border-sm" role="status" />
                          : <i className="bi bi-search" />}
                      </button>
                    )}
                  </div>
                </div>
                <div className="col-md-5 mb-3">
                  <label className="form-label">Nome *</label>
                  <input type="text" className="form-control" name="nome" value={form.nome} onChange={handleChange} required />
                </div>
              </div>
              <div className="row">
                <div className="col-md-4 mb-3">
                  <label className="form-label">Email</label>
                  <input type="email" className="form-control" name="email" value={form.email} onChange={handleChange} />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Telefone</label>
                  <TelefoneMaskInput name="telefone" value={form.telefone} onChange={handleChange} />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Celular</label>
                  <CelularMaskInput name="celular" value={form.celular} onChange={handleChange} />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Logradouro</label>
                  <input type="text" className="form-control" name="logrNome" value={form.logrNome} onChange={handleChange} />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">Número</label>
                  <input type="text" className="form-control" name="logrNum" value={form.logrNum} onChange={handleChange} />
                </div>
              </div>
              <div className="row">
                <div className="col-md-4 mb-3">
                  <label className="form-label">Complemento</label>
                  <input type="text" className="form-control" name="logrCompl" value={form.logrCompl} onChange={handleChange} />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Bairro</label>
                  <input type="text" className="form-control" name="logrBairro" value={form.logrBairro} onChange={handleChange} />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">CEP</label>
                  <CEPMaskInput name="logrCep" value={form.logrCep} onChange={handleChange} />
                </div>
              </div>
              <div className="row">
                <div className="col-md-2 mb-3">
                  <label className="form-label">UF</label>
                  <select className="form-select" name="logrUf" value={form.logrUf} onChange={handleChange}>
                    <option value="">Selecione...</option>
                    {ufs.map((uf, i) => <option key={i} value={uf.sigla}>{uf.sigla}</option>)}
                  </select>
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Cidade</label>
                  <select className="form-select" name="logrCidade" value={form.logrCidade} onChange={handleChange} disabled={!form.logrUf}>
                    <option value="">Selecione...</option>
                    {cidades.map((c, i) => <option key={i} value={c.nome}>{c.nome}</option>)}
                  </select>
                </div>
              </div>
              <div className="d-flex justify-content-end gap-2">
                <button type="button" className="btn btn-secondary" onClick={onClose}>Cancelar</button>
                <button type="submit" className="btn btn-success">Salvar</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FavorecidoModal;
